import { Component, OnInit } from '@angular/core';
import { DateFormatPipe } from '../../../shared/pipes/formatting.pipe';

@Component({
  selector: 'app-maintenance-order',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
})
export class MaintenanceComponent implements OnInit {
  endTime!: string;
  endDate!: string;
  isSameDay = false;
  impactCallCentre = false;

  constructor(private readonly datePipe: DateFormatPipe) {}

  get dateString() {
    if (this.isSameDay) return '';

    return ` on ${this.datePipe.transform(this.endDate)}`;
  }

  ngOnInit() {
    const maintenanceCookie = this.getCookie('maintenance_mode_active');
    if (maintenanceCookie) {
      try {
        const config = JSON.parse(decodeURIComponent(maintenanceCookie));
        this.endTime = config.endTime;
        this.endDate = config.endDate;
        this.impactCallCentre = config.impactCallCentre;
        this.isSameDay =
          new Date().toISOString().split('T')[0] === config.endDate;
      } catch (e) {
        console.error('Error parsing maintenance cookie', e);
      }
    }
  }

  private getCookie(name: string) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift();
    return null;
  }
}
